import React from "react";
import ProductView from "./ProductView";

const ProductDetailPage: React.FC = () => {
  return <ProductView />;
};

export default ProductDetailPage;
